import React, { useState, useEffect } from "react";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import moment from "moment";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import axios from "axios";
import { getGlobals } from "../../Configs";
import {
  DataGridPro,
  gridRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { vRdxUserInfo } from "../../Redux/roStore";
import HeaderComponent from "./ProcessComponent/HeaderComponent";
import FreshDCMarginUpdateModal from "./FreshDCMarginUpdateModal";
import { getStatusStyleV1 } from "../../Utility/Utilitys";

const FreshDcMargin = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const type = ["DateWise"];
  const [LocationData, setLocationData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [isPopModalDataChanged, setIsPopModalDataChanged] = useState(false);

  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const baseURL = getGlobals().API_BASE_URL;

  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    Loc: LocationData?.length > 0 ? LocationData[0]?.UId : "",
    type: "DateWise",
  });

  const handleLoadBtn = () => {
    fLoad(filterObj.Loc);
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
    setOpen(true);
  };

  const apiRef = useGridApiRef();
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };

  const columns = [
    { field: "A_VocTyp", headerName: "A_VocTyp", Width: 100, hide: true },
    { field: "VocName", headerName: "Doc.Name", flex: 1, minWidth: 240 },
    { field: "A_VocNo", headerName: "Doc.No", width: 110 },
    {
      field: "A_VocDt",
      headerName: "Doc.Date",
      width: 100,
      align: "center",
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },
    { field: "LocName", headerName: "Location", width: 140 },
    {
      field: "A_Dept",
      headerName: "A_Dept",
      width: 140,
      align: "center",
      hide: true,
    },
    { field: "Deptname", headerName: "Department", width: 200 },
    {
      field: "Completed",
      headerName: "Status",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
        {
      field: "DocStatus",
      headerName: "DC.Margin",
      align: "center",
      headerAlign: "center",
      minWidth: 80,
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "PostedBy",
      headerName: "DC.PostedBy",
      width: 160,
    },
    {
      field: "PostedDt",
      headerName: "PostedDt",
      width: 100,
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },
    { field: "Type", headerName: "Type", width: 80 },
  ];

  const fLocation = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const vRdxUserInfoObj = vRdxUserInfo();

    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/Location_List`,
        {
          UserCd: vRdxUserInfoObj?.UserID,
        }
      );

      if (response.status === 200) {
        setLocationData(response?.data?.recordset);
        setFilterObj((prev) => ({
          ...prev,
          Loc: response?.data?.recordset[0]?.UId,
        }));
        fLoad(response?.data?.recordset[0]?.UId);
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      loader.style.display = "none";
    }
  };

  const fLoad = async (Loc) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const vRdxUserInfoObj = vRdxUserInfo();

    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLA_Summary_Getrow_DC_Margin`,
        {
          FromDt: moment(filterObj.dateFrom).format("MM/DD/YYYY"),
          ToDt: moment(filterObj.dateTo).format("MM/DD/YYYY"),
          Loc: Loc,
          CNTRL_PUR: "N",
          UserCd: vRdxUserInfoObj?.UserID,
        }
      );

      if (response.status === 200) {
        const resp = response?.data?.data;

        setSummaryData(resp?.summary);
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      loader.style.display = "none";
    }
  };

  useEffect(() => {
    fLocation();
  }, []);

  return (
    <Box sx={{ mx: 1.5 }}>
      <Box pt={vMediaQuery ? 0 : 2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={9}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 1 }}
              >
                Fresh DC Margin
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Fresh DC Margin
            </Typography>

            <HeaderComponent
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              handleLoadBtn={handleLoadBtn}
              handlePrint={handlePrint}
              handleExport={handleExport}
              LocationData={LocationData}
              type={type}
              vMediaQuery={vMediaQuery}
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 1 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: { xs: "75vh", sm: "70vh", md: "70vh", lg: "70vh" },
            width: "100%",
          }}
        >
          <DataGridPro
            apiRef={apiRef}
            rowHeight={30}
            headerHeight={40}
            rows={summaryData}
            getRowId={(v) => v.id}
            columns={columns}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowDoubleClick={handleRowClick}
          />
        </Box>

        {vMediaQuery && (
          <CmpModal
            open={openFilterModal}
            onClose={() => setOpenFilterModal(false)}
            title="Filter"
            width={"95%"}
            height={"auto"}
            component={
              <HeaderComponent
                closeModal={() => setOpenFilterModal(false)}
                handleLoadBtn={handleLoadBtn}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                handlePrint={handlePrint}
                handleExport={handleExport}
                LocationData={LocationData}
                type={type}
                vMediaQuery={vMediaQuery}
              />
            }
          />
        )}
      </Box>

      <CmpModal
        open={open}
        onClose={() => {
          if (isPopModalDataChanged) {
            fLoad(filterObj.Loc);
            setIsPopModalDataChanged(true);
          }
          setIsPopModalDataChanged(false);
          setOpen(false);
        }}
        width={vMediaQuery ? "95%" : "95%"}
        height={vMediaQuery ? "85vh" : "85vh"}
        title="Filter"
        component={
          <FreshDCMarginUpdateModal
            open={open}
            data={selectedRow}
            setSelectedRow={setSelectedRow}
            setIsPopModalDataChanged={setIsPopModalDataChanged}
          />
        }
      />
    </Box>
  );
};
export default FreshDcMargin;
